import React from 'react';
import { Box, TableCell, TableRow } from '@mui/material';
import ImageNotSupportedOutlinedIcon from '@mui/icons-material/ImageNotSupportedOutlined';
import StoreChip from '../../../Components/StoreChip/StoreChip';

interface ListingRowProps {
  listing: any;
}

const ListingRow: React.FC<ListingRowProps> = ({ listing }) => {
  const minPrice = Math.min(...listing.variants.map((v: any) => v.price));
  const maxPrice = Math.max(...listing.variants.map((v: any) => v.price));
  const totalInventory = listing.variants.reduce(
    (acc: number, variant: any) => acc + variant.inventoryQuantity,
    0
  );

  return (
    <TableRow>
      <TableCell>
        {listing.images[0]?.src ? (
          <img
            src={listing.images[0].src}
            alt={listing.images[0].altText || 'Product image'}
            style={{ width: 50, height: 50, objectFit: 'cover' }}
          />
        ) : (
          <Box
            role="img"
            aria-label={`${listing.title} — no image available`}
            sx={{
              width: 50,
              height: 50,
              border: '1px solid #eee',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#bdbdbd',
            }}
          >
            <ImageNotSupportedOutlinedIcon fontSize="small" />
          </Box>
        )}
      </TableCell>
      <TableCell>{listing.title}</TableCell>
      <TableCell>
        <StoreChip shopDomain={listing.shop_domain} />
      </TableCell>
      <TableCell>{listing.vendor}</TableCell>
      <TableCell>{listing.product_type}</TableCell>
      <TableCell>
        {minPrice} - {maxPrice}
      </TableCell>
      <TableCell>{totalInventory}</TableCell>
      <TableCell>{listing.variants.map((variant: any) => variant.sku).join(', ')}</TableCell>
      <TableCell>{listing.status}</TableCell>
    </TableRow>
  );
};

export default ListingRow;
